<template>
  <landing-page label="factSheet.osteroporsis" labelColor="#603813" descColor="#603813" :eggImgObj="{ componentName: 'factsheet', imgName: 'osteoporosisLandingImage', imgFormat: 'png' }" :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }" />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div v-html="t('factSheet.osteoporosisDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.symptomsOfOsteoporosis") }}</div>

      <div v-html="t('factSheet.symptomsOfOsteoporosisDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.whoHigherRisk") }}</div>
      <ol>
        <template v-for="(item, index) in factSheetStore.osteoporosisHigherRiskList" :key="'osteoporosisHigherRisk' + index">
          <li>{{ t(item.label) }}</li>
          <div class="text-description" v-if="item.desc">{{ t(item.desc) }}</div>
          <ul class="bullet-big mt-12 mb-12" v-if="item.list">
            <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
              <li v-html="t(listItem)" />
            </template>
          </ul>
        </template>
      </ol>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.sufferingFromOsteoporosis") }}</div>
      <div v-html="t('factSheet.sufferingFromOsteoporosisDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.osteoporosisKnowList" :key="'osteoporosisKnow' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.osteoporsisPreventable") }}</div>
      <div v-html="t('factSheet.osteoporsisPreventableDesc')" class="space-y-5" />
    </div>

    <div>
      <ol>
        <template v-for="(item, index) in factSheetStore.osteoporosisBalancedDietList" :key="'obesityIdealWeight' + index">
          <li class="mt-12">{{ t(item.label) }}</li>
          <div class="text-description" v-if="item.desc">{{ t(item.desc) }}</div>
          <ul class="bullet-big space-y-12">
            <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
              <li v-html="t(listItem)" />
            </template>
          </ul>
        </template>
      </ol>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.doIfSuffFromOsteoporsis") }}</div>
      <div v-html="t('factSheet.doIfSuffFromOsteoporsisDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.concludeingRemarks") }}</div>
      <div v-html="t('factSheet.concludeingRemarksDesc')" class="space-y-5" />
    </div>

    <div v-html="t('factSheet.osteoporsisRef')" class="mt-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.osteoporosis") }}</div>
      </div>

      <div>
        <div v-html="t('factSheetChinese.osteoporosisDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.symptomsOfOsteoporosis") }}</div>
        <div v-html="t('factSheetChinese.symptomsOfOsteoporosisDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.whoHigherRisk") }}</div>
        <ol>
          <template v-for="(item, index) in factSheetStore.osteoporosisHigherRiskList" :key="'osteoporosisHigherRisk' + index">
            <li>{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</li>
            <div class="text-description" v-if="item.desc">{{ t(item.desc.replace("factSheet", "factSheetChinese")) }}</div>
            <ul class="bullet-big mt-12 mb-12" v-if="item.list">
              <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
                <li v-html="t(listItem.replace('factSheet', 'factSheetChinese'))" />
              </template>
            </ul>
          </template>
        </ol>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.sufferingFromOsteoporosis") }}</div>
        <div v-html="t('factSheetChinese.sufferingFromOsteoporosisDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.osteoporosisKnowList" :key="'osteoporosisKnow' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.osteoporsisPreventable") }}</div>
        <div v-html="t('factSheetChinese.osteoporsisPreventableDesc')" class="space-y-5" />
      </div>

      <div>
        <ol>
          <template v-for="(item, index) in factSheetStore.osteoporosisBalancedDietChineseList" :key="'obesityIdealWeight' + index">
            <li class="mt-12">{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</li>
            <div class="text-description" v-if="item.desc">{{ t(item.desc.replace("factSheet", "factSheetChinese")) }}</div>
            <ul class="bullet-big">
              <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
                <li v-html="t(listItem.replace('factSheet', 'factSheetChinese'))" />
              </template>
            </ul>
          </template>
        </ol>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.doIfSuffFromOsteoporsis") }}</div>
        <div v-html="t('factSheetChinese.doIfSuffFromOsteoporsisDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.concludeingRemarks") }}</div>
        <div v-html="t('factSheetChinese.concludeingRemarksDesc')" class="space-y-5" />
      </div>

      <div v-html="t('factSheetChinese.osteoporsisRef')" class="mt-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>